import {AiFillHome, BiMessageAltMinus, BiSearch, RiUserLine} from "react-icons/all"
import {IconContext} from "react-icons";
import {Link} from "react-router-dom"
import create from "../assets/img/create.svg"
const Tabbar =()=> {
  return (
    <div>
    <nav id="Tabbar" class="fixed-bottom">
    <IconContext.Provider value={{ color: 'white', size: '30px' }}>
      <Link to="/">
        <AiFillHome />
      </Link>
      <BiSearch/>
      <img src={create} />
      <BiMessageAltMinus/>
      <Link to="/following">
        <RiUserLine/>
      </Link>
      </IconContext.Provider>
    </nav>
    </div>
  )
}

export default Tabbar